import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom, Observable, of, tap } from 'rxjs';
import { INavItem, } from '../interfaces/ICommon';
import { IPermissionMap, IResetPassword, IToken, IUser, IUserRole } from '../interfaces/IUser';
import { APP_URL, STORAGE_KEY } from '../shared/constants';
import { NAV_ADMIN, NAV_USER } from './../shared/constants';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  loggerUser: IUser | null = null;
  navigationMenu: INavItem[] = [];
  activateEmail: string;
  permissions: IPermissionMap;

  constructor(
    private http: HttpService,
    private router: Router) { }

  login(data: any): Observable<any> {
    return this.http.post('Auth/Authenticate', data);
  }

  getAccessToken() {
    const token = localStorage.getItem(STORAGE_KEY.APP_ID) ?? '';
    return token.split('.Da9nAng.')[0];
  }

  getRefreshToken() {
    const token = localStorage.getItem(STORAGE_KEY.APP_ID) ?? '';
    return token.split('.Da9nAng.')[1];
  }

  setLocalStorage(id: string) {
    localStorage.removeItem(STORAGE_KEY.APP_ID);
    localStorage.setItem(STORAGE_KEY.APP_ID, id);
  }

  refreshToken(tokenApi: any) {
    return this.http.post('Auth/RefreshToken', tokenApi);
  }

  signOut() {
    localStorage.removeItem(STORAGE_KEY.APP_ID);
    sessionStorage.clear();
    this.loggerUser = null;
    //this.oidcSecurityService.logoff().subscribe(() => window.location.reload());
  }

  // check user saved in subject, if user exist get from subject, else call api
  // it will not call back every time new value is pushed to user Subject
  // Get user data, fetch from API if not cached
  setAuthData(): Observable<any> {
    if (this.loggerUser) {
      return of(this.loggerUser);
    }
    return this.http.get('User');
  }

  setPermission(companyId: string): Observable<any> {
    if (this.permissions) {
      return of(this.permissions)
    }
    return this.http.get(`Company/Permissions/${companyId}`).pipe(tap((res: any) => this.permissions = res));
  }

  refreshPermission(companyId: string) {
    return this.http.get(`Company/Permissions/${companyId}`).pipe(tap((res: any) => this.permissions = res));
  }

  getSSOToken(): Observable<any> {
    return this.http.get('Auth/SingleSignOn');
  }

  forgotPassword(data: any) {
    return this.http.post('Auth/ForgotPassword', data);
  }

  verifyToken(data: IToken): Observable<any> {
    return this.http.post('Auth/VerifyToken', data);
  }

  resetPassword(data: IResetPassword) {
    return this.http.post('Auth/ResetPassword', data);
  }

  redirectUnauthenticated(url: string): Promise<boolean> {
    // handle login page
    if (url.includes(APP_URL.LOGIN)) {
      return Promise.resolve(true);
    }
    // Prevent app access if not logged in
    return this.router.navigateByUrl("").then(() => false);
  }

  redirectAuthenticated(url: string): Promise<boolean> {
    // Prevent login access if already logged in
    if (url === APP_URL.LOGIN) {
      return this.router.navigateByUrl(this.isAdmin() ? APP_URL.ADMIN_DASHBOARD : APP_URL.DEED);
    }

    if (url.includes(APP_URL.ADMIN)) {
      //Check is admin or not
      this.navigationMenu = NAV_ADMIN;
      return Promise.resolve(true);
      // TODO: Prevent admin access without permission
    }

    if (this.isAdmin()) {
      return this.router.navigateByUrl(APP_URL.ADMIN_DASHBOARD);
    }

    this.navigationMenu = NAV_USER;
    // TODO: Prevent user access without permission
    return Promise.resolve(true);
  }

  // Check token and user information
  isAuthenticated = async (): Promise<boolean> => {
    if (!this.getAccessToken()) {
      return false;
    }
    this.loggerUser = await firstValueFrom(this.setAuthData());

    if (this.loggerUser?.userRoles?.[0].companyId) await firstValueFrom(this.setPermission(this.loggerUser.userRoles[0].companyId));
    //Return true if user, token is not null or undefined
    return !!this.loggerUser;
  };

  isAdmin(): boolean {
    return this.loggerUser?.userRoles?.some((u: IUserRole) => u.role === 1) ?? false;
  }
}
